import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no tag open
export const Route = createFileRoute('/_authenticated/tags/')({});
